import { MultiThemeSiteSpecificComponentsProvider } from '@orgnc/core/lib/themes/SiteSpecificComponentsProvider';
import BaseApp from '@orgnc/core/lib/wordpress/pages/_app.page';
import GlobalStyles from '@mui/material/GlobalStyles';

import React from 'react';
import NavigationChangeHandler from '@/utils/navigationChangeHandler';
import { multiTheme } from '../theme';
import {
  crimsonText,
  inter,
  lato,
  merriWeather,
  merriWeatherSans,
  openSans,
  russoOne,
} from '../utils/localFonts';
import { getStatusCode } from '../utils/getStatusCode';
import StaticApp from '../components/StaticApp';

type AppProps = Parameters<typeof BaseApp>[number];

const App: typeof BaseApp &
  React.FunctionComponent<AppProps & { isError?: boolean }> = (props) => {
  const isError = 'isError' in props ? props.isError : false;

  if (isError) {
    return (
      <StaticApp>
        <props.Component {...props.pageProps} />
      </StaticApp>
    );
  }

  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${inter.style.fontFamily};
          font-family: ${merriWeather.style.fontFamily};
          font-family: ${merriWeatherSans.style.fontFamily};
          font-family: ${openSans.style.fontFamily};
          font-family: ${crimsonText.style.fontFamily};
          font-family: ${lato.style.fontFamily};
          font-family: ${russoOne.style.fontFamily};
        }
      `}</style>
      <GlobalStyles
        styles={{
          '[data-og-block-type="core/gallery"] figcaption': {
            fontSize: '18px',
          },
          '[data-og-block-type="core/gallery"] figcaption > a': {
            color: 'white !important',
            textDecorationColor: 'white !important',
          },
          '.carousel figcaption': {
            fontSize: '18px',
            color: 'white',
          },
          '.carousel figcaption a': {
            // mirrors MuiLink styling
            textDecoration: 'underline',
            color: 'white !important',
            textDecorationColor: 'white !important',
          },
        }}
      />
      <MultiThemeSiteSpecificComponentsProvider
        hostname={props.requestHost ?? null}
        multiTheme={multiTheme}
      >
        <NavigationChangeHandler />
        <BaseApp {...props} />
      </MultiThemeSiteSpecificComponentsProvider>
    </>
  );
};

App.getInitialProps = async (appContext) => {
  const statusCode = getStatusCode(appContext.ctx);
  const isError = statusCode >= 400;

  const baseAppProps = BaseApp.getInitialProps
    ? await BaseApp.getInitialProps(appContext)
    : { pageProps: {}, requestHost: undefined };

  return {
    ...baseAppProps,
    isError,
  };
};

export default App;
